import Cookies from 'js-cookie'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import { JOB_THEMES } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'
import { trackRatingWidget } from '@/tracking'

import { WIDGET_URL, WIDGET_COOKIE, WIDGET_MAX_JOB_VIEWS, WIDGET_TIMEOUT, YF_STORAGE_START_TIME, YF_STORAGE_REMAINING_TIMEOUT } from '../constants'
import { saveRemainingTimeoutToStorage } from '../utils'

import { addViewedJob, renderRatingWidget, renderRatingWidgetAfterTimeout, setViewedJobs, showWidget } from './actions'
import { getShowWidget, getViewedJobs, getEnabled } from './selectors'

export const delay = (ms) => new Promise((res) => setTimeout(res, ms), null)

export function * render () {
  const isWidgetEnabled = yield select(getEnabled)
  const isWidgetShown = yield select(getShowWidget)
  if (!isWidgetEnabled || isWidgetShown) {
    return
  }
  const script = document.createElement('script')
  script.src = WIDGET_URL
  script.defer = 'defer'
  document.head.appendChild(script)
  yield put(showWidget(true))
  window.removeEventListener('unload', saveRemainingTimeoutToStorage)
  window.sessionStorage.removeItem(YF_STORAGE_START_TIME)
  window.sessionStorage.removeItem(YF_STORAGE_REMAINING_TIMEOUT)
  const widgetCookie = Cookies.get(WIDGET_COOKIE)
  if (!widgetCookie || !JSON.parse(widgetCookie).hide) {
    trackRatingWidget()
  }
}

export function * renderIfJobsViewed ({ payload: jobId }) {
  const enabled = yield select(getEnabled)
  const pageType = yield select(getPageType)
  const viewedJobs = yield select(getViewedJobs)

  if (!enabled || viewedJobs.includes(jobId) || JOB_THEMES.includes(pageType)) {
    return null
  }
  if (viewedJobs.length >= WIDGET_MAX_JOB_VIEWS) {
    yield call(render)
  } else {
    yield put(setViewedJobs([...viewedJobs, jobId]))
  }
}

export function * renderAfterTimeout () {
  const isWidgetEnabled = yield select(getEnabled)
  const pageType = yield select(getPageType)
  if (isWidgetEnabled && !JOB_THEMES.includes(pageType)) {
    window.sessionStorage.setItem(YF_STORAGE_START_TIME, new Date().getTime())
    const remainingTimeout = parseInt(window.sessionStorage.getItem(YF_STORAGE_REMAINING_TIMEOUT))
    window.addEventListener('unload', saveRemainingTimeoutToStorage, { once: true })
    yield call(delay, remainingTimeout || WIDGET_TIMEOUT)
    yield call(render)
  }
}

export default all([
  takeEvery(renderRatingWidgetAfterTimeout, renderAfterTimeout),
  takeEvery(renderRatingWidget, render),
  takeEvery(addViewedJob, renderIfJobsViewed)
])
